import React from 'react';
import clsx from 'clsx';

export interface CardsProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The cards to display in the stack
   */
  children: React.ReactNode;
  /**
   * Direction of the cards layout
   * @default "column"
   */
  direction?: 'column' | 'row';
  /**
   * Disable borders between cards (only show borders between children)
   * @default false
   */
  disableBorders?: boolean;
}

/**
 * Cards component for stacking cards without gaps, like a menu
 */
export const Cards = React.forwardRef<HTMLDivElement, CardsProps>(
  (
    {
      className,
      children,
      direction = 'column',
      disableBorders = false,
      ...props
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={clsx(
          'prometheus-cards',
          `prometheus-cards--${direction}`,
          {
            'prometheus-cards--no-borders': disableBorders,
          },
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Cards.displayName = 'Cards';

export default Cards;